import { useState, useEffect } from 'react';
import getExtensionistsAssignedContracts from '../helpers/getExtensionistsAssignedContracts'

const useGetExtensionistsAssignedContracts = (Ffin) => {

    const [state, setState] = useState({
        data: [],
        loadingData: true
    })

    useEffect( ()=>{
        getExtensionistsAssignedContracts(Ffin)
            .then( details => {
                setState({
                    data: details,
                    loadingData: false
                })
            } )
      },[Ffin])

    return state

}

export default useGetExtensionistsAssignedContracts